module.exports = __webpack_public_path__ + "static/media/Crown.dfa0e084.svg";